

// SHARED FUNCTIONS IN COMPONENTS AND MAIN COMPONENT:

const COL_KEY_COMP_ITEM_PREFIX = 'compItem_'

const getColKey = (compItemId) => {
    // NOTE: Must keep this in sync with reverse method below!
    return `${COL_KEY_COMP_ITEM_PREFIX}${compItemId}`;
};
const getCompItemIdFromColKey = (colKey) => {
    // reverse of above -- MUST KEEP THESE IN SYNC!
    return colKey.replace(COL_KEY_COMP_ITEM_PREFIX, '');
};
const isCompItemColKey = (colKey) => {
    return colKey.startsWith(COL_KEY_COMP_ITEM_PREFIX);
};
const ALL_TAGS_ON_VENDOR_KEY = 'ALL_TAGS';
const NESTED_TAGS_ON_VENDOR_KEY = 'tags_by_category';  // must match backend!
const getTagCatColKey = (tagCatId) => {
    return `${NESTED_TAGS_ON_VENDOR_KEY}.${tagCatId}`;
};
const isTagColKey = (colKey) => {
    return colKey.startsWith(NESTED_TAGS_ON_VENDOR_KEY) || colKey === ALL_TAGS_ON_VENDOR_KEY;
};


export {
    COL_KEY_COMP_ITEM_PREFIX,
    getColKey,
    getCompItemIdFromColKey,
    isCompItemColKey,
    ALL_TAGS_ON_VENDOR_KEY,
    NESTED_TAGS_ON_VENDOR_KEY,
    getTagCatColKey,
    isTagColKey,
}